import React from 'react';
import PDFViewer from './Programacao';
import pdfConfig from 'json/programacao.json'


const App = () => (
    <div>
        <PDFViewer pdfConfig={pdfConfig} />
    </div>
);

export default App;
